import {
  ComposeV3DeviceBatteryConfig,
  ComposeV3DeviceCountryCode,
  ComposeV3DeviceInputModeConfig,
  ComposeV3DeviceLogicalInterface,
  ComposeV3DeviceLogicalInterfaces,
  ComposeV3DeviceResistanceConfig,
  ComposeV3DeviceWorkModeConfig,
  V3CurrentBuckBoost,
  V3DCI,
  V3DeviceBatteryConfig,
  V3DeviceCountry,
  V3DeviceInputModeConfig,
  V3DeviceInputTypeChannelConfig,
  V3DeviceLogicalInterface,
  V3DeviceResistanceConfig,
  V3DeviceWorkModeConfig,
  V3LogicalInterface,
  V3VoltageBus,
} from './device-info';
import {
  ComposeV3RealTimeConfig,
  V3BatteryAttributeByRegister,
  V3DeviceGridConfig,
  V3EnergyAttributesByRegister,
  V3InternalEnergy,
  V3PowerAttributeByRegister,
  V3RealTimeDataByRegister,
} from './device-dashboard';
import { DSerialNumberAndVersionComposer, V3SerialNumberAndVersion } from './generics';
import { V3HistoryEvents } from './device-logs';
import { ComposeV3DeviceModbusSettings, V3ModbusSettings } from './device-settings';
import { AvoidType, DataType, InverterDataComposer, ReadWrite, RegisterTable } from '../lib/inverter.model';

export const V3ChatBotRequestJump: Partial<RegisterTable> = {
  AddressMask_Realtime_ElectricityStatistics1: {
    address: 0x0680,
    name: 'Address mask realtime electricity statistics',
    dataType: DataType.U64,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'validity of 64 addresses',
    quantity: 1,
    avoid: AvoidType.SKIP_REGISTER,
    isMask: true,
  },
};

export const V3ChatBotRequest: Partial<RegisterTable> = {
  ...V3BatteryAttributeByRegister,
  ...V3CurrentBuckBoost,
  ...V3DCI,
  ...V3DeviceBatteryConfig,
  ...V3DeviceCountry,
  ...V3DeviceGridConfig,
  ...V3DeviceInputModeConfig,
  ...V3DeviceInputTypeChannelConfig,
  ...V3DeviceLogicalInterface,
  ...V3DeviceResistanceConfig,
  ...V3DeviceWorkModeConfig,
  ...V3EnergyAttributesByRegister,
  ...V3HistoryEvents,
  ...V3InternalEnergy,
  ...V3LogicalInterface,
  ...V3ModbusSettings,
  ...V3PowerAttributeByRegister,
  ...V3RealTimeDataByRegister,
  ...V3SerialNumberAndVersion,
  ...V3VoltageBus,

  /** Address to jump to the next page */
  ...V3ChatBotRequestJump,
};

export const ComposeV3ChatBotRequest: Partial<InverterDataComposer> = {
  BatConfig_Protocol: ComposeV3DeviceBatteryConfig.BatConfig_Protocol,
  BatConfig_Cell_Type: ComposeV3DeviceBatteryConfig.BatConfig_Cell_Type,
  ...ComposeV3DeviceCountryCode,
  ...ComposeV3DeviceInputModeConfig,
  ...ComposeV3DeviceLogicalInterface,
  ...ComposeV3DeviceLogicalInterfaces,
  ...ComposeV3DeviceModbusSettings,
  ...ComposeV3DeviceResistanceConfig,
  ...ComposeV3DeviceWorkModeConfig,
  ...ComposeV3RealTimeConfig,
  ...DSerialNumberAndVersionComposer,
};
